// Normalisierung nutzer-verfasster Block-Texte (Audit 2026-09-24, Multi-Lingual).
//
// - NFC: Vietnamesisch kommt aus manchen IMEs/Dokumenten in NFD (Grundbuchstabe
//   + kombinierendes Tonzeichen). detectScript sah dann „Latein", die Schrift
//   war falsch und der Text rund 20 % länger (ElevenLabs zählt Zeichen).
// - NBSP (U+00A0, U+202F) → normales Leerzeichen: kommt beim Einfügen aus
//   Word/Mail und aus manchen IMEs; im contentEditable serialisiert Chrome es
//   als `&nbsp;`, wodurch der Abgleich DOM ↔ Modell bei jedem Input scheiterte
//   und Block.tsx mitten in einer IME-Komposition innerHTML neu setzte.
//
// Wird an der Eingabe (Block.tsx handleInput) und beim Seed aus dem Skript
// angewendet — eine Stelle, damit Modell, Skript.txt und TTS-Request gleich
// aussehen.

export function normalizeBlockText(text: string): string {
  return text.normalize('NFC').replace(/[\u00A0\u202F]/g, ' ');
}

/** Für den Abgleich DOM ↔ Modell: `&nbsp;`/NBSP im serialisierten innerHTML
 *  wie ein Leerzeichen behandeln. */
export function normalizeDomHtml(html: string): string {
  return html.replace(/&nbsp;|[\u00A0\u202F]/g, ' ');
}
